const summary = state => state.summary
const monthlyCost = state => state.monthlyCost
const dailyCost = state => state.dailyCost
const resourceId = state => state.resourceId
const usageAccountId = state => state.usageAccountId
const region = state => state.region
const productCode = state => state.productCode
const productCategory = state => state.productCategory
const itemDescription = state => state.itemDescription
const availableTags = state => state.availableTags
const tag = state => state.tag
const detail = state => state.detail
const status = state => state.status

export default {
    summary,
    monthlyCost,
    dailyCost,
    resourceId,
    usageAccountId,
    region,
    productCode,
    productCategory,
    itemDescription,
    availableTags,
    tag,
    detail,
    status
}
